<div class="flex flex-col gap-6 min-w-[30vw] min-h-40">
  @if (!!localData) {
    <div class="flex gap-4 items-center ">
      <label class="font-semibold w-24">Name</label>
      <span class="font-normal" [class.bg-yellow-50]="localData.userType === UserType.Casual">{{localData.name}} {{getUserTypeSuffix(localData)}}</span>
    </div>

    <div class="flex gap-4 items-center">
      <label class="font-semibold w-24">Type</label>
      <span class="font-normal">{{localData.userType}}</span>
    </div>

    <div class="flex gap-4 items-center">
      <label class="font-semibold w-24">Email</label>
      <span class="font-normal">{{localData.email}}</span>
    </div>

    <div class="flex gap-4 items-center">
      <label class="font-semibold w-24">Manager</label>
      <span class="font-normal">{{(localData.manager?.name ?? '-') + ( localData.manager?.email ? ' (' + localData.manager?.email  + ')' : '')}}</span>
    </div>

    <div class="flex gap-4 items-center">
      <label class="font-semibold w-24">Tier</label>
      <p-select
        [(ngModel)]="selectedTier"
        [options]="tierList()"
        optionLabel="name"
        placeholder="Select tier..."
        appendTo="body"
        class="flex-1"
        size="small"
      />
    </div>

    <div class="flex flex-col gap-2">
      <label class="font-semibold">Groups</label>

      <div class="flex flex-col gap-1 max-w-[600px]">
        @for (group of localData.permissionSummary?.groups; track group.id) {
          <div class="w-full h-[1px] bg-surface-200"></div>
          <div class="flex items-center justify-between">
            <div class="flex flex-col pl-1">
              <span class="text-sm font-medium py-1">{{group.name}}</span>
            </div>
            @if (this.allowedCode(group.code ?? '')) {
              <p-button severity="secondary" size="small" (onClick)="removeGroup(group)" [text]="true">
                <div class="flex gap-2 items-center">
                  <div class="text-sm text-slate-500">Remove</div>
                  <div class="rounded-full w-5 h-5 flex items-center justify-center text-white bg-surface-400 text-lg font-medium">
                    <i class="fa-solid fa-minus fa-2xs"></i>
                  </div>
                </div>
              </p-button>
            }
          </div>
        } @empty {
          <div class="pl-1 text-sm"><i>No groups selected.</i></div>
        }
      </div>

      <div class="flex gap-2 items-center">
        <p-select
          [formControl]="groupControl"
          [options]="availableGroups"
          (onChange)="addSelectedGroup($event)"
          optionLabel="name"
          placeholder="Add group..."
          appendTo="body"
          class="flex-1"
          size="small"
        />
      </div>
    </div>

    <div class="inline-grid grid-cols-[auto_auto_auto_auto_1fr] gap-x-3 gap-y-2 items-center">
      <label class="font-semibold">Active</label>
      <div class="w-12" [pTooltip]="'Active users are staff currently part of the organisation.'">
        <i class="fa-regular fa-circle-question fa-xl text-primary"></i>
      </div>
      <div class="flex justify-end">
        <p-tag class="w-fit" severity="danger" rounded value="Inactive" />
      </div>
      <p-toggleswitch [(ngModel)]="localData.isActive" [disabled]="!this.canManageUsers()"/>
      <p-tag class="w-fit" severity="info" rounded value="Active" />

      <label class="font-semibold">Can Submit TAs</label>
      <div class="w-12" [pTooltip]="'Controls whether this user can submit new TAs'">
        <i class="fa-regular fa-circle-question fa-xl text-primary"></i>
      </div>
      <div class="flex justify-end">
        <p-tag class="w-fit" severity="danger" rounded value="No" />
      </div>
      @if (localData.isActive) {
        <p-toggleswitch [(ngModel)]="canSubmit" [disabled]="!this.canManageUsers()"/>
      } @else {
        <p-toggleswitch [ngModel]="false" [disabled]="true"/>
      }
      <p-tag class="w-fit" severity="info" rounded value="Yes" />


    </div>

    @if (isSystemAdmin) {
      <div class="flex flex-col gap-2">
        <label class="font-semibold"> System Permissions</label>

        <div class="flex flex-col gap-1 max-w-[600px]">
          @for (perm of activePermissions; track perm.key) {
            <div class="w-full h-[1px] bg-surface-200"></div>
            <div class="flex items-center justify-between">
              <span class="text-sm font-medium py-1 pl-1">{{ perm.key }}</span>
              <div class="flex gap-1">
                @for (scope of perm.scopes; track scope) {
                  <p-tag
                    class="w-fit"
                    [severity]="'secondary'"
                    rounded
                    [value]="scope"
                  />
                }
              </div>
            </div>
          } @empty {
            <div class="pl-1 text-sm"><i>No permissions assigned.</i></div>
          }
        </div>
      </div>
    }
  }

  <div class="flex-1"></div>

  <div class="flex justify-end gap-2">
    <p-button
      size="small"
      label="Save"
      severity="primary"
      icon="fa-regular fa-save"
      (click)="closeDialog(localData)"
    />
    <p-button
      size="small"
      label="Cancel"
      severity="danger"
      icon="fa-regular fa-cancel"
      (click)="closeDialog()"
    />
  </div>

</div>
